
import Vue from 'vue'

export default Vue.extend({
  props: {
    modalId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      confirmationChecked: false
    }
  },
  methods: {
    confirmationDone () {
      this.$emit('confirmation-done')
      this.confirmationChecked = false
      this.closeModal()
    },
    closeModal () {
      this.confirmationChecked = false
      const modal = document.getElementById(this.modalId)
      modal!.style.display = 'none'
    }
  }
})
